import React from 'react';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import { Delete, Warning } from '@mui/icons-material';

interface DeleteFacilityDialogProps {
  open: boolean;
  facility: any | null;
  onCancel: () => void;
  onConfirm: () => void;
  formatMoney: (amount: number) => string;
}

export const DeleteFacilityDialog: React.FC<DeleteFacilityDialogProps> = ({
  open,
  facility,
  onCancel,
  onConfirm,
  formatMoney
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Warning color="warning" />
          Confirm Facility Deletion
        </Box>
      </DialogTitle>
      <DialogContent>
        {facility && (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Are you sure you want to remove <strong>{facility.org_name}</strong> from this case?
            </Typography>

            <Alert severity="warning" sx={{ mb: 2 }}>
              This action will remove the facility from the case and update financial totals. Any
              scheme instances for this facility will also be unassigned from this case.
            </Alert>

            <Box
              sx={{
                p: 2,
                bgcolor: 'grey.50',
                borderRadius: 1,
                border: 1,
                borderColor: 'grey.200'
              }}
            >
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                Financial Impact:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • Total Billed: <strong>{formatMoney(facility.total_billed || 0)}</strong> will be
                removed
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • Total Paid: <strong>{formatMoney(facility.total_paid || 0)}</strong> will be
                removed
              </Typography>

              {facility.owners && facility.owners.length > 0 && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    • Affected Owners: {facility.owners.join(', ')}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="error" startIcon={<Delete />}>
          Remove Facility
        </Button>
      </DialogActions>
    </Dialog>
  );
};